module.exports = __webpack_public_path__ + "static/media/uaic-building.52763c52.png";